import ReactDOM from "react-dom/client";
import App from "./App";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/** Start session init ASAP so TLS + /session/init overlap React boot (fewer sequential RTs before first data API). */

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ToastContainer
      hideProgressBar={true}
      position="top-right"
      autoClose={2000}
      draggable
      theme="colored"
      style={{ zIndex: 99999 }}
    />
    <App />
  </>,
);
